import { MouseEvent } from 'react';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import CustomProvider from 'components/CustomProvider';
import * as styles from './styles/styles.module.scss';
import { toATLocalString } from '../../utils/number_util';
import ProBadge from '../../../assets/images/icons/pro-badge-white-bg.svg';

const message = defineMessages({ allTrailsPro: { defaultMessage: 'AllTrails Pro' } });

export type ActionBarProps = {
  className?: string;
  count?: number;
  disabled?: boolean;
  href?: string;
  icon: JSX.Element;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  showPro?: boolean;
  target?: '_blank' | '_self' | '_parent';
  title: string;
  testId: string;
};

const ActionBarItem = ({
  title,
  count,
  onClick,
  showPro = false,
  icon,
  href,
  target = '_self',
  disabled = false,
  className,
  testId
}: ActionBarProps): JSX.Element => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  let localizedCountDisplay = null;

  if (count) {
    localizedCountDisplay = ` (${toATLocalString(count, languageRegionCode)})`;
  }

  return (
    <CustomProvider>
      <li className={classNames(styles.container, className)} title={title}>
        <a
          className={classNames(styles.link, className, disabled ? styles.disabled : '')}
          href={href}
          onClick={handleClick}
          target={target}
          data-testid={testId}
        >
          <div className={styles.iconContainer}>
            {icon}
            {showPro && <img alt={intl.formatMessage(message.allTrailsPro)} className={styles.proBadge} src={ProBadge} />}
          </div>
          <span className={styles.title}>
            {title}
            {localizedCountDisplay}
          </span>
        </a>
      </li>
    </CustomProvider>
  );
};

export default ActionBarItem;
